import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from "../Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds , MobileUnderCalAds } from "../../Ads";
const TITLE = "حساب وتر المثلث - حاسبة وتر المثلث";
const DESCRIPTION =
  "استخدم حاسبة الوتر لحساب طول الوتر في المثلث القائم الزاوية بسهولة ودقة. أدخل أطوال الأضلاع للحصول على النتيجة مع شرح خطوات الحل.";
const KEYWORDS =
  "حاسبة الوتر, حساب الوتر, مثلث قائم الزاوية, فيثاغورس, الرياضيات, حسابات هندسية";
const OG_URL = "https://do-calculate.com/calculator/ar/hypotenuse-calculator/";
function HypotenuseCalculator() {
  const [sideA, setSideA] = useState("");
  const [sideB, setSideB] = useState("");
  const [result, setResult] = useState(null);
  const [steps, setSteps] = useState([]);
  const [error, setError] = useState("");
  const handleCalculate = () => {
    try {
      if (!sideA || !sideB) {
        setError("يرجى إدخال طول الضلعين.");
        return;
      }
      const a = parseFloat(sideA);
      const b = parseFloat(sideB);
      const hypotenuse = Math.sqrt(a * a + b * b).toFixed(2);
      const step1 = `مربع الضلع الأول: ${a}^2 = ${a * a}`;
      const step2 = `مربع الضلع الثاني: ${b}^2 = ${b * b}`;
      const step3 = `جمع مربعي الضلعين: ${a * a} + ${b * b} = ${a * a + b * b}`;
      const step4 = `الجذر التربيعي للمجموع: √(${
        a * a + b * b
      }) = ${hypotenuse}`;
      setSteps([step1, step2, step3, step4]);
      setResult(hypotenuse);
      setError("");
    } catch (err) {
      setError("حدث خطأ أثناء الحساب. يرجى المحاولة مرة أخرى.");
    }
  };
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  هل تريد أن تفهم كيف تعمل نظرية فيثاغورس في الحياة العملية؟ هذه
                  الحاسبة هي الأداة المثالية لك! بإدخال طول ضلعي المثلث القائم
                  الزاوية، ستحصل على طول الوتر بالإضافة إلى شرح مبسط لكيفية
                  استخدام نظرية فيثاغورس لحل المسألة.
                </p>
                <p>
                  <strong>الوتر^2 = الضلع الأول^2 + الضلع الثاني^2</strong>
                </p>
                <p>
                  نظرية فيثاغورس تنص على أن مربع طول الوتر في المثلث القائم
                  الزاوية يساوي مجموع مربعي طولي الضلعين الآخرين. هذه الحاسبة
                  تستخدم هذه النظرية لحساب طول الوتر بسهولة وسرعة. فقط أدخل طول
                  الضلعين المعطيين، وستحصل على النتيجة المطلوبة، بالإضافة إلى
                  شرح مبسط لكيفية تطبيق نظرية فيثاغورس على مسألتك.
                </p>
                <p>
                  تم تطوير هذه الحاسبة لتسهيل عملية حساب الوتر مع توضيح خطوات
                  الحل لضمان الفهم الكامل.
                </p>
                <hr />
              </div>
              <br />
            </div>
             <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <div dir="rtl">
                  <div>
                    <hr />
                    <div className="form-group" htmlFor="sideA">
                      <label className="form-label ms-2">
                        أدخل طول الضلع الأول (سم)
                      </label>
                      <input
                        id="sideA"
                        type="number"
                        value={sideA}
                        onChange={(e) => setSideA(e.target.value)}
                        placeholder="أدخل طول الضلع الأول"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <div className="form-group" htmlFor="sideB">
                      <label className="form-label ms-2">
                        أدخل طول الضلع الثاني (سم)
                      </label>
                      <input
                        id="sideB"
                        type="number"
                        value={sideB}
                        onChange={(e) => setSideB(e.target.value)}
                        placeholder="أدخل طول الضلع الثاني"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px", marginLeft: "10px" }}
                      onClick={handleCalculate}
                    >
                      احسب                    </button>
                  </div>
                  <br />
                  { error !== "" && (
                    <p className="p-3 mb-2 bg-warning text-black">
                      خطأ: {error}
                    </p>
                  )}
                  {result &&  (
                    <div className="p-3 mb-2 bg-success text-white">
                      <h4>النتيجة: {result} سم</h4>
                      <p className="text-white">
                        <strong>الخطوات:</strong>
                      </p>
                      <ul className="text-white">
                        {steps.map((step, index) => (
                          <li key={index}>{step}</li>
                        ))}
                      </ul>
                    </div>
                  )}
                  <hr />
                </div>
              </div>
            </div>
            <hr />            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                ما هو الوتر في المثلث القائم الزاوية؟
              </div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>مفهوم الوتر</h2>
                  </u>
                  <p>
                    الوتر هو أطول ضلع في المثلث القائم الزاوية، ويقع مقابل
                    الزاوية القائمة. يمكن حسابه باستخدام نظرية فيثاغورس التي تنص
                    على أن مجموع مربعي أطوال الضلعين الآخرين يساوي مربع طول
                    الوتر.
                  </p>
                  <div className="p-3 mb-2 bg-info text-black">
                    مثال: إذا كان طول الضلعين الآخرين 3 سم و4 سم، فإن طول الوتر
                    يساوي: √(3^2 + 4^2) = 5 سم
                  </div>
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>كيفية حساب طول الوتر</h2>
                  </u>
                  <p>
                    لحساب طول الوتر في مثلث قائم الزاوية، اتبع الخطوات التالية:
                  </p>
                  <ul>
                    <li>أدخل أطوال الضلعين القائمين في الصيغة المناسبة.</li>
                    <li>احسب مربعي الأطوال المدخلة.</li>
                    <li>أوجد مجموع مربعي الأطوال.</li>
                    <li>احسب الجذر التربيعي للمجموع للحصول على طول الوتر.</li>
                  </ul>
                  <div className="p-3 mb-2 bg-info text-black">
                    مثال: إذا كان طول الضلعين 6 سم و8 سم، فإن طول الوتر يساوي:
                    √(6^2 + 8^2) = 10 سم
                  </div>
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>الأسئلة الشائعة</h2>
                  </u>
                  <p>إجابات لبعض الأسئلة الشائعة حول الوتر وحسابه.</p>
                  <div className="p-3 mb-2 bg-info text-black">
                    سؤال: لماذا نستخدم الجذر التربيعي لحساب الوتر؟
                    <br />
                    جواب: الجذر التربيعي يستخدم لتحويل مجموع مربعات أطوال
                    الضلعين إلى طول فعلي يمثل المسافة المباشرة بين الزاويتين
                    المتقابلتين (الوتر).
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
         </div>
</div>
  );
}
export default HypotenuseCalculator;
